@for (option of options; track option) {
  <div class="option" [ngClass]="{chosen: option.chosen}" (click)="choose(option)">
    {{option.name}}
  </div>
}
